export default {
  data() {
    return {
      text: '',
      isTextFocused: false,
      textArea: '',
      isAreaFocused: false,
      textAreaShort: '',
      isAreaShortFocused: false,
      textMinUnder: '',
      isTextMinUnderFocused: false,
      textMinOver: '',
      isTextMinOverFocused: false
    }
  },
  computed: {
    isTextInputted() {
      return this.text.length !== 0
    },
    isTextAreaInputted() {
      return this.textArea.length !== 0
    },
    isTextAreaShortInputted() {
      return this.textAreaShort.length !== 0
    },
    isTextMinUnderInputted() {
      return this.textMinUnder.length !== 0
    },
    isTextMinOverInputted() {
      return this.textMinOver.length !== 0
    }
  },
  methods: {
    // テキスト
    onFocus() {
      this.isTextFocused = true
    },
    onBlur() {
      this.isTextFocused = false
    },
    // テキストエリア
    onFocusArea() {
      this.isAreaFocused = true
    },
    onBlurArea() {
      this.isAreaFocused = false
    },
    // テキストエリア(小)
    onFocusAreaShort() {
      this.isAreaShortFocused = true
    },
    onBlurAreaShort() {
      this.isAreaShortFocused = false
    },
    // テキスト（ミニ/下限なし）
    onFocusTextMinUnder() {
      this.isTextMinUnderFocused = true
    },
    onBlurTextMinUnder() {
      this.isTextMinUnderFocused = false
    },
    // テキスト（ミニ/上限なし）
    onFocusTextMinOver() {
      this.isTextMinOverFocused = true
    },
    onBlurTextMinOver() {
      this.isTextMinOverFocused = false
    }
  }
}
